module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Kidnapped By the Taliban: A Story of Terror, Hope, and Rescue By Seal Team Six")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct2",
    attrs: {
      "id": "p0023-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#con1",
      "id": "cap1"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "ct3"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#con1"
    }
  }, [_c('b', [_vm._v("FINDING MY WAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "p0023-02-1"
    }
  }, [_vm._v("7:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNDAY")]), _vm._v(", N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVEMBER")]), _vm._v(" 18, 2012 ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLORADO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRINGS")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLORADO")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0023-03-2"
    }
  }, [_vm._v("ON THE NIGHT BEFORE MY TRIP TO AFGHANISTAN, THOUGHTS of kidnapping and death were the furthest things from my mind. I was instead relaxing on a couch in my home. My focus was not on the intentions of armed men but on the adventures of a trio of small trucks, otherwise known as "), _c('i', [_vm._v("The Three Little Rigs")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-04-4"
    }
  }, [_vm._v("“Little rig, little rig, let me come in!” I read aloud in my best imitation of a talking wrecking ball. “Not by the chrome on my chinny chin chin!” I answered myself, trying now to sound like a young truck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-04-5"
    }
  }, [_vm._v("In my lap sat my son, three-year-old Tobi, his ears absorbing every word and his wide eyes taking in every detail of the picture book I held in my hands. Snuggled next to us was my oldest son, five-year-old Jaron. On another couch across the room, my wife, Cilicia, read a book to our oldest child, eight-year-old Asha. On the floor in a corner, the newest addition to our family, eight-month-old Eshaan, played with his puzzle toy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-7"
    }
  }, [_vm._v("I love my roles as husband and father. Anyone with children understands the rewards and joys of raising a family. I had anticipated this "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v(" before Cilicia and I started having kids. What surprised me, however, was how much my family has taught me—especially about parts of my character that still need work. When money was tight and Cilicia spent more than I thought appropriate on an outing with friends, I realized I was lacking in grace. When my kids were louder before bedtime than I initially thought was necessary, I realized I needed more patience.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-2"
    }
  }, [_vm._v("Of course, my family also has taught me about each of them. I particularly enjoy uncovering the mystery of each child’s personality. Asha, for example, revels in her role as the oldest. She is a born leader, passionate and driven, with a strong sense of justice and fairness. Jaron is more easygoing, sensitive, and reflective. He often comes up with insights that surprise me. Tobiah—we call him Tobi—is what Cilicia terms “a sunshine.” He enjoys being the center of attention and knows how to draw others to him through his smiling face, his friendly and persistent questions, and his silly antics.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-03-5"
    }
  }, [_vm._v("Eshaan seems to be easygoing, like his brother Jaron, but it is too soon to know much for certain. I especially look forward to understanding him better in the months and years ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-04-7"
    }
  }, [_vm._v("Cilicia, meanwhile, is a devoted and incredibly patient mother. She is also an amazingly genuine person with a warm heart. From the beginning of our relationship, I found talking with her encouraging and energizing. After nearly twenty years of these conversations, including a decade of marriage, that still hasn’t changed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-05-10"
    }
  }, [_vm._v("I let out a contented sigh as I glanced around the room. Like any married couple, Cilicia and I had our ups and downs. And certainly, raising four young kids isn’t always easy. But I realized I am truly blessed. As I approached my forties, I could not imagine wanting any other life.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Yet, once again, I was going to walk away from the people I most cherished and put all this on hold. I tried to freeze in my mind the image of my family all around me. The last night before I traveled overseas always felt bittersweet—my excitement and anticipation over the upcoming trip mixed with the knowledge that it would be a few weeks before I saw my loved ones again.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx2t",
    attrs: {
      "id": "p0025-02-2"
    }
  }, [_vm._v("I would miss them. But this was a call I could not ignore.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0025-03-4"
    }
  }, [_vm._v("You could say that call started with my parents. Both were natives of India, living in Kerala on the country’s southwest coast. My father, P. V. Joseph, was in his early twenties and leading a youth group meeting when he met my mom, Rosamma, five years younger. They fell in love. Most families in India, then and now, abide by an arranged marriage system. My father and mother were thrilled when their families connected and sanctioned their union. To commemorate his joy over their new life together, my father began calling my mother Jolly (pronounced Joe-Lee).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-04-6"
    }
  }, [_vm._v("My sister, Deepa, was born a year after the wedding. I arrived two years after that, on July 28, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-8"
    }
  }, [_vm._v("Kerala is a diverse state, where today more than half the population is Hindu, another quarter is Muslim, and nearly 20 percent is Christian. Both of my parents grew up in Christian households and committed their lives to Jesus Christ at a young age. They launched an independent church movement that included services held in various people’s homes. Ours was one of them. People constantly came and went, sometimes staying for days or weeks at a time.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-06-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Among my strongest childhood memories, however, is what we did outside of our home. Virtually every weekend we and other members ")]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" of our home church traveled to another neighborhood to hand out food or help with other practical needs. Even though they didn’t have much, my parents made it a priority to do what they could for those who were struggling physically, emotionally, financially, or spiritually.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-P-1"
    }
  }, [_vm._v("One of those struggling people was a man my dad came across during one of his monthly hospital visits. Jacob was in his late twenties and desperately needed a blood transfusion. Dad arranged for a businessman in our fellowship group to give blood for the transfusion. At the last minute, however, the donor had to back out. So my dad, even though he has a slight build and is not a particularly strong man, decided to donate the blood himself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-02-2"
    }
  }, [_vm._v("Jacob was so impressed with my dad’s efforts that he began attending our home church. Later he even asked my father to officiate at his wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-03-4"
    }
  }, [_vm._v("Throughout my childhood my parents demonstrated a great love for each other and for people around them, including those they didn’t know. In their way, my parents were rebels, determined to defy the status quo and live out what they believed in. Although I didn’t realize it then, their emphasis on love, service, and following one’s beliefs made a lasting impression on me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-04-6"
    }
  }, [_vm._v("I was also tremendously impressed by a documentary I watched when I was eleven. It was about a Japanese doctor who traveled to China’s remote interior in the late 1800s to offer medical aid and love through his faith. The doctor lived in the villages with the people he served. I realized he had chosen a difficult assignment, yet it was exciting to see the expressions on people’s faces—a mixture of caution, curiosity, and appreciation. This courageous doctor was eventually killed by government forces because his presence and beliefs were deemed a threat.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("I was inspired by the idea of traveling to another country as a doctor and humanitarian—and by this doctor’s commitment, despite the danger. I dreamed of doing the same one day.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-02-2"
    }
  }, [_vm._v("When I was fifteen, the traveling part of my dream came true. My dad—thanks in part to the encouragement and prodding of my mom—had moved to the United States two years before to study at Fuller Theological Seminary in Pasadena, California. Once I completed the Indian version of high school, the rest of the family and I joined him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-03-5"
    }
  }, [_vm._v("At first, America overwhelmed me. Everything here was huge. On the drive from Los Angeles International Airport to Pasadena, I was amazed by the skyscrapers, massive bridges, and interlocking concrete freeways.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-04-7"
    }
  }, [_vm._v("But I adjusted quickly. I was something of a social butterfly, and when I joined the junior class at Marshall Fundamental High School, I made many friends. I was active, joining the science and key clubs and the tennis team. I enjoyed immersing myself in American culture.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-04-8"
    }
  }, [_vm._v("I might have enjoyed myself a little too much. Academic success came easily to me at Marshall, and I didn’t challenge or prepare myself as I should have for college. When I enrolled at nearby Azusa Pacific University in 1991, I found the courses far tougher. I didn’t make my path any easier when I chose biochemistry as my major.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-05-10"
    }
  }, [_vm._v("My time at Azusa was marked by two life-changing events. The first occurred during my junior year when I went to a seminar on polymerase chain reaction, at that time a new biochemical technique. It was chemistry of a different sort, however, that made that class memorable.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-06-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("The room was packed, fifty people in a space designed to hold thirty. I managed to find a chair in the back row. Right after I sat ")]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v(" down, the guest speaker began his opening remarks—except I didn’t hear a word. I’d noticed a girl sitting directly in front of me in the next row. I could see only the back of her head and the side of her face, but her long dark hair and attractive features immediately grabbed my attention.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-02-2"
    }
  }, [_c('i', [_vm._v("Who is she?")]), _vm._v(" Since I didn’t recognize her, I decided she must be a freshman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-03-4"
    }
  }, [_vm._v("It turned out that this pretty girl was indeed a freshman, and a family friend of one of my best friends, also a student at Azusa. Cilicia had grown up in both Southern and Northern California. Her father was originally from India while her mother was a Caucasian American who’d also grown up in Northern California.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-04-6"
    }
  }, [_vm._v("Cilicia was dating another friend of mine on campus, so I saw her occasionally and gradually got to know her. I enjoyed her company and considered her a cherished friend, but since she was dating someone else, I didn’t allow myself to think of anything more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-05-8"
    }
  }, [_vm._v("The next year was my last in college. For my final semester I enrolled in an art history class, one of my last requirements for graduation. I enjoyed the class, but I enjoyed one of my classmates even more: Cilicia. She and her boyfriend had broken up, and the more we talked that semester, the more our friendship grew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-06-10"
    }
  }, [_vm._v("All too soon, however, the course ended. I was graduating and needed to figure out what I would do with my life. Cilicia was thinking about transferring to a school closer to home. After that last art history class, we walked to a McDonald’s for a burger and sat down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-06-11"
    }
  }, [_vm._v("“It’s been great to get to know you a little bit,” Cilicia said with a warm smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-07-13"
    }
  }, [_vm._v("“It has for me too,” I agreed. “I hope you have a fun life. I hope we keep in touch.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("We thought we were saying good-bye, but it turned out to be just the beginning. Over the next few months my thoughts kept returning to Cilicia. I missed her friendship and our easy conversations. Something about her was so engaging. We continued to talk occasionally by phone and e-mail, and when she called six months later to let me know she was coming to visit family in the area, we decided to go out for dinner. Seeing her again after all that time, I could no longer hide my feelings from her—or myself. Over pizza in a booth at the Cheesecake Factory in Pasadena, I confessed that I was strongly attracted to her. I was thrilled and relieved when Cilicia said she felt the same way.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx2t",
    attrs: {
      "id": "p0029-02-2"
    }
  }, [_vm._v("Amid all the uncertainty in my life, this felt right. It was the start of a long-distance and very long-term courtship.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0029-03-4"
    }
  }, [_vm._v("The second transforming event of my college years was more traumatic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-04-6"
    }
  }, [_vm._v("It was early evening on a Saturday, August 12, 1995. I was visiting my parents in Pasadena for the weekend and had just returned to their house after being out all day. A month before, my dad had earned his doctor of missiology degree from Fuller. Now my parents were in the final stages of planning a return to India to launch a program for tribal people there. I had spoken to my mom that morning and knew they were planning to join friends for dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-05-8"
    }
  }, [_vm._v("I noticed the light on the answering machine blinking red. The message was alarming: “This is Huntington Hospital. We are trying to reach the son of P. V. and Jolly Joseph. Please call us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-06-10"
    }
  }, [_vm._v("Deeply concerned, I immediately returned the call and was told, “You need to come in. Your parents have been in an accident.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("I pressed for more information even though I was afraid to hear the answer: “Are they okay?”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-02-2"
    }
  }, [_vm._v("After a moment’s hesitation, the woman on the other line gently responded. “Your dad is in the ICU. But I’m sorry to say that your mom passed away.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-03-4"
    }
  }, [_vm._v("In shock, I hung up the phone and stood there, unable to move or breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-04-6"
    }
  }, [_c('i', [_vm._v("No. This can’t be. There’s no way this can be real. There must be a mistake.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-05-8"
    }
  }, [_vm._v("I later learned a woman had driven through a red light and smashed her Chevy Suburban into the side of my parents’ Nissan sedan. Dad suffered significant internal injuries. Mom was declared dead at the hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-06-10"
    }
  }, [_vm._v("Those next two weeks of dealing with the grief, family and friends, a funeral and memorial service, and my dad’s hospital care were a blur. Losing Mom was devastating. I’d always been close to her. Now I felt that the anchor of my life had been ripped away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2t",
    attrs: {
      "id": "p0030-07-13"
    }
  }, [_vm._v("After about six months, my dad recovered from his physical injuries and decided to move back to India. I knew I should finish my undergraduate degree at Azusa, but then what? I decided to postpone any thoughts of graduate school. I needed a break. It was a difficult, uncertain time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0030-08-15"
    }
  }, [_vm._v("After graduating from Azusa Pacific, I took a job at a USC research lab while I tried to figure out my future. I thought I might want to pursue a career in biomedical research. Always in the back of my mind, however, was the documentary I’d seen of the Japanese doctor in China and the idea of helping people with medical needs in underdeveloped nations.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("After two years I left the research lab to enter graduate school at Loma Linda University. Thanks in part to the encouragement of my best friend, I decided to pursue a master’s degree in public health rather than medical research. My focus at Loma Linda was originally on biostatistics. When I began a master’s internship overseas, however, I finally found the path that truly resonated with my heart.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-02-2"
    }
  }, [_vm._v("I was back in India, serving for three months in a rural area near the town of Jamkhed in the state of Maharashtra. There I saw the dramatic effects one doctor and a little health education could have on a community. It might have been only routine checkups and asking a few simple questions—“Are your kids healthy? Have you followed up on the nutrition lesson we talked about last time?”—combined with a brief exam. Yet for most people in these villages, it was so much more medical attention than they were accustomed to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-03-4"
    }
  }, [_vm._v("I saw that a small medical facility, coupled with a strong community health education program, led to positive, long-term changes. Our influence went beyond medical considerations. When we treated villagers with courtesy and kindness, it generated smiles. We could see the people felt valued. When we left them, they felt better, not just physically but also mentally, emotionally, and spiritually.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-04-7"
    }
  }, [_vm._v("Then there was the social impact. Even today, many people in India look down on members of what are considered the lower castes. When we provided medical training to villagers who were part of these lower castes, it raised their status in the community and empowered them. People of the higher castes now had to go to and learn from these villagers if they wanted to improve their health.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-05-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Those three months near Jamkhed changed my life. I saw how I could make a difference in the world. The connection to my childhood dream was complete. My mom had always encouraged me to ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" pursue a career in medicine. By combining my master’s degree in international public health with a medical degree, I could honor those wishes and fulfill the purpose I was now certain I’d been born for. For the first time since my mother’s death, I was excited about the future.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx2t",
    attrs: {
      "id": "p0032-P-1"
    }
  }, [_vm._v("I began a medical program in Cambridge, England. At the same time, despite the challenges of living thousands of miles apart, my relationship with Cilicia grew deeper and stronger. On August 17, 2002, in front of nearly three hundred family and friends and with Cilicia’s father officiating, we said our wedding vows and committed our lives to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0032-02-2"
    }
  }, [_vm._v("Now, ten years and four kids later, I was enjoying life with my family in Colorado Springs. I scooped Eshaan off the floor and carried him upstairs. After a quick diaper change, I slipped him into a fresh onesie and his tiny sleeping bag—the white one with multicolored letters of the alphabet on it—and walked into the bedroom he shared with his sister. I turned off the light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-03-4"
    }
  }, [_vm._v("Eshaan yawned as I cradled him in my arms. Silently I offered up his good-night prayer: "), _c('i', [_vm._v("God, please be with Eshaan while I’m away. Protect him and mold him for your purposes and plans for his life. Be with us both until we meet again.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-04-7"
    }
  }, [_vm._v("I didn’t want to lay him down just yet. Instead, I studied Eshaan’s face in the shadows, absorbing every feature: his tiny nose and mouth, the dark hair on his head, his brown eyes, already heavy and ready to close. I wanted to memorize this precious image.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-05-9"
    }
  }, [_c('i', [_vm._v("How much will he change in the month I’ll be gone? How will he react when I return? Will he recognize me?")]), _vm._v(" I hadn’t left yet, and I missed him already.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Reluctantly I laid Eshaan in his crib and gently kissed him on his forehead. I’d given my heart to this little guy, just as I’d given it to his sister and brothers, to his mother, and to the nation I now called home. Another country was calling me, however, a country that had also earned a piece of my heart.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-02-2"
    }
  }, [_vm._v("I wondered what adventures awaited Eshaan. His journey was only just beginning. I realized I would have to wait to find out. It was time to continue my own journey.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-689d3c8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 81
// module chunks = 0